<template>
    <vue-good-table
      :columns="finalColumns"
      :rows="rows"
      :search-options="mergedSearchOptions"
      :pagination-options="mergedPaginationOptions"
      :line-numbers="showIndex"
      :loading="loading"
    >
        <template #emptystate>
            <div class="p-0 text-center text-muted">
            Nenhum registro encontrado.
            </div>
        </template>
  
        <template #table-row="props">
          <slot name="table-row" v-bind="props" />
        </template>

    </vue-good-table>
  </template>
  
  <script>
  export default {
    name: 'BaseTable',
    props: {
      columns: {
        type: Array,
        required: true,
      },
      rows: {
        type: Array,
        required: true,
      },
      searchOptions: Object,
      paginationOptions: Object,
      showIndex: {
        type: Boolean,
        default: false,
      },
      showActions: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      mergedSearchOptions() {
        return {
          enabled: true,
          placeholder: 'Buscar ...',
          ...this.searchOptions,
        };
      },
      mergedPaginationOptions() {
        return {
          enabled: true,
          perPage: 5,
          perPageDropdown: [5, 10, 20, 50],
          dropdownAllowAll: true,
          mode: 'pages',
          nextLabel: 'Próximo',
          prevLabel: 'Anterior',
          rowsPerPageLabel: 'Linhas por página',
          ofLabel: 'de',
          allLabel: 'Todos',
          pageLabel: 'Página',
          ...this.paginationOptions,
        };
      },
      finalColumns() {
        const base = [...this.columns];
        if (this.showActions) {
          base.push({
            label: 'Ações',
            field: '__actions',
          });
        }
        return base;
      },
    },
  };
  </script>
  